module.exports = __webpack_public_path__ + "static/media/check.aa0f2f53.png";